import React, { useEffect, useState } from "react";
import { abpnClient } from "../../Services/AbpnClient";
import { PortalUser } from "../Shared/Models/PortalUser";
import { AuthContext } from "./AuthProvider";

interface IProfileProviderProps {
    user: PortalUser
}
export const ProfileContext = React.createContext<IProfileProviderProps>(null);

export const ProfileProvider = (props: any) => {
    const [user, setUser] = useState<PortalUser>(null);
    var auth = React.useContext(AuthContext);

    useEffect(() => {
        const loadUser = async () => {
            let userResult = await abpnClient.get<PortalUser>("/api/profile/getcurrentuser", auth);

            if ((userResult.physicianId !== user?.physicianId) && (userResult.otherBoardPhysicianId !== user?.otherBoardPhysicianId)) {
                setUser(userResult);
            }
        }
        if (auth.isAuthenticated()) {
            loadUser();
        }
    }, [])

    return <ProfileContext.Provider value={{user}}> { props.children }</ ProfileContext.Provider>;
}